import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { Profile } from "./profile"
import { IProfile } from "./profile.types"

export interface IProfileRaw {
  displayName: string
  givenName: string
  surname: string
  jobTitle: string
  mail: string
  mobilePhone: string
  officeLocation: string
  preferredLanguage: string
  userPrincipalName: string
}

export const ProfileParser: IParser<IProfile, IProfileRaw> = {
  toDomain: (data: IProfileRaw) => {
    try {
      return new Profile({
        displayName: data.displayName,
        givenName: data.givenName,
        surname: data.surname,
        jobTitle: data.jobTitle,
        email: data.mail,
        mobilePhone: data.mobilePhone,
        officeLocation: data.officeLocation,
        preferredLanguage: data.preferredLanguage,
        userPrincipalName: data.userPrincipalName,
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
